// extracted by mini-css-extract-plugin
module.exports = {"flexCenterSection":"ProductIndex_flexCenterSection__BZHJ4","bannerPosition":"ProductIndex_bannerPosition___VXCK"};